<ng-container *ngIf="{
  deviceId: _deviceId$ | async,
  status: statusHeatPump$ | async,
  properties: selectedHeatPumpProperties$ | async
} as resolver">
  <app-generic-device-dashboard
    [title]="labels.title"
    [uiFramework]="uiFramework"
    [status]="resolver.status"
    [deviceId]="resolver.deviceId"
    [deviceTypeLabel]="labels.deviceTypeValue"
    [deviceImageSrc]="productImageSrc"
    [defaultImageSrc]="'blocks-assets/images/productImages/monitoring/heat-pump.svg'"
    [properties]="resolver.properties">
  </app-generic-device-dashboard>
</ng-container>